/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendDataDto } from '../../models/backend-data-dto';

export interface MonitoringPlanProfitAndLossPlanDataRetrieve$Params {
  /**
   * Номер страницы. По умолчанию 1.
   */
  page?: number;

  /**
   * Период финансовых данных ("month" или "year"). По умолчанию "month".
   */
  period?: 'month' | 'year';
  scenario_id: number;
}

export function monitoringPlanProfitAndLossPlanDataRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringPlanProfitAndLossPlanDataRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendDataDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringPlanProfitAndLossPlanDataRetrieve.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('period', params.period, {});
    rb.path('scenario_id', params.scenario_id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendDataDto>;
    }),
  );
}

monitoringPlanProfitAndLossPlanDataRetrieve.PATH = '/api/monitoring/plan/profit_and_loss_plan_data/{scenario_id}/';
